import React, { createContext, useContext, useEffect, useState } from 'react';
import moment from 'moment-timezone';

export const PriceContext = createContext();
export const PriceProvider = ({ children }) => {
  const [message, setMessage] = useState([]);
  const [activeMessageId, setActiveMessageId] = useState(null); 
  const [activeBalanceDue, setActiveBalanceDue] = useState(null);
  const [confirmation, setConfirmation] = useState(false);
  const [redirectOptions, setRedirectOptions] = useState(false);
  const [redirectDashboard, setRedirectDashboard] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  
  
  
  const [paymentData, setPaymentData] = useState({
    email: '',
    wordcount: '',
    deliveryTurnaround: '',
    deadline: '', 
    documentType: '',
    couponCode: [],
    services: {
      DRR: false,
      Video: false,
      Review: false,
      Consult: false,
      Investigate: false,
      Audio: false,
      Research: false,
      Merge: false,
      Design: false,
      Layout: false,
      Convert: false,
      Compress: false,
    },
    instructions: '', 
    uploadedFiles: [],
    paymentStatus: '',
    amount: ''
  });
  // Function to calculate the deadline
  const calculateDeadline = (deliveryTurnaround) => {
    const deadlineDate = moment.tz('America/New_York');
    if (deliveryTurnaround.includes('4-6hrs')) {
      deadlineDate.add(6, 'hours');
    } else if (deliveryTurnaround.includes('24hrs')) {
      deadlineDate.add(24, 'hours');
    } else if (deliveryTurnaround.includes('72 hours')) {
      deadlineDate.add(72, 'hours');
    } else if (deliveryTurnaround.includes('5-7 days')) {
      deadlineDate.add(7, 'days');
    } else {
      console.error('Invalid delivery turnaround format');
      return null;
    }
    return deadlineDate.format('MMMM D, YYYY');
  };

  const updateDeadline = () => {
    const deadline = calculateDeadline(paymentData.deliveryTurnaround);
    if (deadline) {
      setPaymentData((prevState) => ({
        ...prevState,
        deadline
      }));
    
    }
  };

  useEffect(() => {
    if (paymentData && paymentData.deliveryTurnaround) {
      const deadline = calculateDeadline(paymentData.deliveryTurnaround);
      if (deadline) {
        setPaymentData(prev => ({
          ...prev,
          deadline
        }));
      }
    }
  }, [paymentData?.deliveryTurnaround]);
  

  return (
    <PriceContext.Provider value={{ paymentData, setPaymentData, message, setMessage, activeMessageId, setActiveMessageId, activeBalanceDue, setActiveBalanceDue, paymentSuccess, setPaymentSuccess, confirmation, setConfirmation, redirectOptions, setRedirectOptions, redirectDashboard, setRedirectDashboard, updateDeadline}}>
      {children}
    </PriceContext.Provider>
  );
};
export const defaultPaymentData = {
  email: '',
  wordcount: '',
  deliveryTurnaround: '',
  deadline: '', 
  documentType: '',
  couponCode: [],
  services: {
    DRR: false,
    Video: false,
    Review: false,
    Consult: false,
    Investigate: false,
    Audio: false,
    Research: false,
    Merge: false,
    Design: false,
    Layout: false,
    Convert: false,
    Compress: false,
  },
  instructions: '', 
  uploadedFiles: [],
  paymentStatus: '',
  amount: ''
};

// Custom hook
export const usePriceContext = () => {
  const context = useContext(PriceContext);
  if (context === undefined) {
    throw new Error('usePriceContext must be used within a PriceProvider');
  }
  return context;
};
